import OptionField from '../../../../forms/fields/OptionField';
import CustomerSubjectPanel from './panels/CustomerSubjectPanel';
import FranchiseSubjectPanel from './panels/FranchiseSubjectPanel';

class AllowanceSubjectKindsPanels {
    constructor() {
        this._kinds = [
            {
                value: 'CUSTOMER',
                label: 'Cliente',
                Panel: CustomerSubjectPanel,
                buildFields: ({customerOptions, initialValues = {}}) => ({
                    customerId: new OptionField(customerOptions, false, undefined, initialValues.customerId),
                }),
                buildInitialValues: (businessName) => ({customerId: businessName}),
            },
            {
                value: 'FRANCHISE',
                label: 'Franquicia',
                Panel: FranchiseSubjectPanel,
                buildFields: ({franchiseBrandOptions, initialValues = {}}) => ({
                    franchiseBrandId: new OptionField(franchiseBrandOptions, false, undefined, initialValues.franchiseBrandId),
                }),
                buildInitialValues: (businessName) => ({franchiseBrandId: businessName}),
            },
        ];
    }

    options() {
        return this._kinds.map(kind => ({label: kind.label, value: kind.value}));
    }

    panelFor(value) {
        return this._kindWith(value)?.Panel;
    }

    buildFieldsFor(value, formOptions) {
        return this._kindWith(value)?.buildFields(formOptions);
    }

    initialValuesFor(value, businessName) {
        return this._kindWith(value)?.buildInitialValues(businessName);
    }

    _kindWith(value) {
        return this._kinds.find(kind => kind.value === value);
    }
}

export default AllowanceSubjectKindsPanels;
